import React, {CSSProperties} from 'react';
import {RequestStatus, ScreenType} from "Constants";
import ReservationService from 'Services/reservation.service';
import RBContainer from "Generic/Buttons/ViewControllerBtns/RBContainer";
import "./styles.sass";
import {MvSortTable} from 'Generic/MvSortTable';
import {Tip} from 'Interfaces/TipInterface';

// @ts-ignore
import {LocalizationContext} from "react-localize";
// @ts-ignore
import sessionStorage from "store/storages/sessionStorage";

import {GetReservationsResult, ReservationDetailsExtended, ReservationType} from 'Interfaces/GetReservations';
import {MvResortModal, MvRoomModal} from 'Generic/MvModal';
import {
    ReservationViewFields,
    showReservationField,
    ManagementCompanyType,
    SiteType
} from 'Interfaces/AYPResultInterface';
import moment, {Moment} from 'moment';
import {RoomModal} from 'Interfaces/RoomModalInterface';
import {MvConfirmationModal} from 'Generic/MvConfirmationModal/MvConfirmationModal';

// Constants
import {InitRoomModal} from "Constants/InitInterfaces";

// Utils
import {sortReservations, SortDirection, SortType} from 'Utils/SortReservations';
import MultiSelectDate from 'Generic/MultiSelectDate/multi-select-date.component';
import {DropdownOption} from 'Interfaces/MultiSelectDate';
import MvReservationTypeToolTip from 'Generic/ToolTip/MvReservationTypeToolTip/MvReservationTypeToolTip';
import {Position} from 'Generic/ToolTip/ToolTip';
import {ReactAppMode} from 'Interfaces/ReactAppModes';
import {EXEC_MODE} from "../../../cfg";
import CancelUnavaliableModal from '../CancelReservation/CancelUnavailableModal/CancelUnavailableModal';
import { trackAnalyticData } from 'Utils/analytics';
import { MvHopperConfirmationModal } from './ConfirmationModal/HopperConfirmationModal';


enum ModalTypes {
    ROOM_MODAL = "room_modal",
};

type Props = {
    token: string;
    lang: string;
    resId: number; //this should not apply because this is a list of resIds
    setScreenType(screenType: ScreenType, aypResId?: number, waitListId?: number, reservationType?: ReservationType): void;
    apiTimeout: string;
    vcapmpmId: string;
    vcapctaType: string;
};

type State = {
    reservations: GetReservationsResult[];
    activeBtn: ReservationType;
    [ReservationType.UPCOMING]: {
        requestStatus: RequestStatus;
        reservations: GetReservationsResult[];
        totalReservations: GetReservationsResult[];
        defaultYears: number[];
        datesFilter: DropdownOption[];
        [SortType.DESTINATION]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.DATES]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.TRANSACTION_DATE]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.RESERVATION_TYPE]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
    },
    [ReservationType.PAST]: {
        requestStatus: RequestStatus;
        reservations: GetReservationsResult[];
        totalReservations: GetReservationsResult[];
        defaultYears: number[];
        datesFilter: DropdownOption[];
        [SortType.DESTINATION]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.DATES]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.TRANSACTION_DATE]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.RESERVATION_TYPE]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
    },
    [ReservationType.CANCELED]: {
        requestStatus: RequestStatus;
        reservations: GetReservationsResult[];
        totalReservations: GetReservationsResult[];
        defaultYears: number[];
        datesFilter: DropdownOption[];
        [SortType.DESTINATION]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.DATES]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.TRANSACTION_DATE]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
        [SortType.RESERVATION_TYPE]: {
            curSortDirection: SortDirection;
            activeSort: boolean;
        };
    },
    roomModal: RoomModal;
    resortModal: {
        show: boolean;
        propertyCode: string;
    };
    windowWidth: number;
    windowHeight: number;
    showErrorModal: boolean;
    showHotelConfirmation: boolean;
    reservationConfirmationNum: number;
    errorMessage: string;
    [ModalTypes.ROOM_MODAL]: RoomModal,
    roomModalLoaded: boolean;
    singleRoomInfo: any;
    showUnavailableModal: boolean;
    cancelMessage: string;
}

const InitState: State = {
    reservations: [],
    activeBtn: ReservationType.UPCOMING,
    [ReservationType.UPCOMING]: {
        requestStatus: RequestStatus.LOADING,
        reservations: [],
        totalReservations: [],
        datesFilter: [],
        defaultYears: [],
        [SortType.DESTINATION]: {
            curSortDirection: SortDirection.ASC,
            activeSort: false,
        },
        [SortType.DATES]: {
            curSortDirection: SortDirection.ASC,
            activeSort: true,
        },
        [SortType.TRANSACTION_DATE]: {
            curSortDirection: SortDirection.DESC,
            activeSort: false,
        },
        [SortType.RESERVATION_TYPE]: {
            curSortDirection: SortDirection.ASC,
            activeSort: false,
        },
    },
    [ReservationType.PAST]: {
        requestStatus: RequestStatus.LOADING,
        reservations: [],
        totalReservations: [],
        defaultYears: [],
        datesFilter: [],
        [SortType.DESTINATION]: {
            curSortDirection: SortDirection.ASC,
            activeSort: false,
        },
        [SortType.DATES]: {
            curSortDirection: SortDirection.DESC,
            activeSort: true,
        },
        [SortType.TRANSACTION_DATE]: {
            curSortDirection: SortDirection.DESC,
            activeSort: false,
        },
        [SortType.RESERVATION_TYPE]: {
            curSortDirection: SortDirection.ASC,
            activeSort: false,
        },
    },
    [ReservationType.CANCELED]: {
        requestStatus: RequestStatus.LOADING,
        reservations: [],
        totalReservations: [],
        datesFilter: [],
        defaultYears: [],
        [SortType.DESTINATION]: {
            curSortDirection: SortDirection.ASC,
            activeSort: false,
        },
        [SortType.DATES]: {
            curSortDirection: SortDirection.DESC,
            activeSort: false,
        },
        [SortType.TRANSACTION_DATE]: {
            curSortDirection: SortDirection.ASC,
            activeSort: true,
        },
        [SortType.RESERVATION_TYPE]: {
            curSortDirection: SortDirection.ASC,
            activeSort: false,
        },
    },
    roomModal: Object.assign(InitRoomModal, {}),
    resortModal: {
        show: false,
        propertyCode: '',
    },
    windowWidth: 0,
    windowHeight: 0,
    showErrorModal: false,
    showHotelConfirmation: false,
    reservationConfirmationNum: 0,
    errorMessage: '',
    [ModalTypes.ROOM_MODAL]: Object.assign(InitRoomModal, {}),
    roomModalLoaded: false,
    singleRoomInfo: {},
    showUnavailableModal: false,
    cancelMessage: ''
}

class Reservations extends React.Component<Props, State> {
    reservationService: ReservationService;
    _isMounted: boolean;

    constructor(props: Readonly<Props>) {
        super(props);

        this.state = Object.assign({}, InitState);
        this.reservationService = new ReservationService();
        this.setActive = this.setActive.bind(this);
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.onYearFilterSelection = this.onYearFilterSelection.bind(this);
        this.getDateFilterOptions = this.getDateFilterOptions.bind(this);
        this.getYearFromDate = this.getYearFromDate.bind(this);
        this._isMounted = false;
    }

    componentDidMount() {
        this._isMounted = true;
        const selectedTab = localStorage.getItem(`${ScreenType.RESERVATIONS}-tab`);
        if (selectedTab) {
            this.setActive(selectedTab as ReservationType);
        } else {
            this.setActive(ReservationType.UPCOMING);
        }
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
    }

    componentWillUnmount(): void {
        this._isMounted = false;
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        this.setState({windowWidth: window.innerWidth, windowHeight: window.innerHeight});
    }

    toggleshowUnavailableModal = () => {
        this.setState({ showUnavailableModal: !this.state.showUnavailableModal })
    }

    setActive = (key: ReservationType) => {
        localStorage.removeItem(`${ScreenType.RESERVATIONS}-tab`);
        const {localize} = this.context;
        
        // Commenting the if and else code for VNSSC-325 Caching issue
        // if (this.state[key].reservations.length === 0) {
            const newLoadingState = {...this.state};
            newLoadingState[key].requestStatus = RequestStatus.LOADING;
            newLoadingState.activeBtn = key;

            this.setState(newLoadingState, () => {
                this.reservationService.getReservations(key).then(reservations => {
                    //assign value to reservationTypeContent and add to res details for sorting
                    reservations.reservations.map(resDetails => {
                        if (resDetails.reservationDetails.managementCompany) {
                            resDetails.reservationDetails.reservationTypeContent = resDetails.reservationDetails.managementCompany.name;
                        }
                        
                    })
                    const newState = {...this.state};
                    newState[key].reservations = sortReservations(reservations.reservations, key);
                    newState[key].totalReservations = sortReservations(reservations.reservations, key);
                    newState[key].datesFilter = reservations.sortFilter && reservations.sortFilter.year ? this.getDateFilterOptions(reservations.sortFilter.year.range) : [];
                    const defaultYear = reservations.sortFilter && reservations.sortFilter.year ? reservations.sortFilter.year.default : moment().year();
                    newState[key].defaultYears = [defaultYear, defaultYear - 1];
                    newState[key].requestStatus = RequestStatus.LOADED;
                    this.setState(newState, () => {
                        if (key === ReservationType.CANCELED) {
                            this.onSortClicked(key, SortType.TRANSACTION_DATE)
                        }
                    });
                    console.log({reservationsRequest: reservations});
                    console.log("This is today's deployment");
                    //TODO: As per the comment in 1771, we are not displaying default years filters. This may need in the future if we want to implement default year logic 
                    // if(key === ReservationType.PAST || key === ReservationType.CANCELED ){
                    //     this.onYearFilterSelection([], key);
                    // }
                }).catch(error => {
                    console.log({error})
                    const newErroredState = {...this.state};
                    newErroredState[key].requestStatus = RequestStatus.ERRORED;

                    if (error.code !== 401) {
                        const newErroredState = {...this.state};
                        newErroredState[key].requestStatus = RequestStatus.ERRORED;
                        newErroredState.showErrorModal = true;
                        newErroredState.errorMessage = error.message;

                        this.setState(newErroredState);
                    } else {
                        this.setState(newErroredState);
                    }
                });
            });
        // } else {
        //     this.setState({activeBtn: key});
        // }
    }

    toggleErrorModal = () => {
        this.setState({showErrorModal: !this.state.showErrorModal});
    }

    showAllColumns() {
        return this.state.windowWidth > 900;
    }

    getDateFilterOptions(years: number[] = []) {
        if (years && years.length) {
            years.reverse();
            const options = years.map(item => {
                return {year: item, checked: false}
            });
            return options;
        }
        return [];
    }

    /**
     * return the array of headers for the Reservations table
     */
    reservationsTableHeaders(resType: ReservationType) {
        const {localize} = this.context;

        if (this.state[this.state.activeBtn].requestStatus === RequestStatus.LOADED && this.state[resType].reservations.length === 0)
            return [];

        const showAll = this.showAllColumns();

        //confirmation # header text
        let confirmationHeader = localize("static.content.reservations-confirmation");
        if (resType === ReservationType.PAST)
            confirmationHeader = localize("static.content.reservations-reservation-num");
        if (resType === ReservationType.CANCELED)
            confirmationHeader = localize("static.content.reservations-reservation-num");

        const headers : {
            text: string;
            sortable: boolean;
            curSortDirection?: SortDirection;
            onSort?(): void;
            activeSort?: boolean;
            toolTip?: Tip[];
            toolTipPosition?: Position;
        }[] = []
        
        headers.push(
            {
                text: localize("static.content.reservations-destination"),
                sortable: true,
                curSortDirection: this.state[resType][SortType.DESTINATION].curSortDirection,
                onSort: () => {
                    this.onSortClicked(resType, SortType.DESTINATION)
                },
                activeSort: this.state[resType][SortType.DESTINATION].activeSort,
            });

        //only show room type if showing All
        if (showAll) {
            headers.push(
                {
                    text: localize("static.content.reservations-type"),
                    sortable: false,
                    curSortDirection: SortDirection.ASC,
                    onSort: () => {
                    },
                    activeSort: false,
                }
            );
        }

        //always show Dates/Nights
        headers.push(
            {
                text: localize("static.content.reservations-dates"),
                sortable: true,
                curSortDirection: this.state[resType][SortType.DATES].curSortDirection,
                onSort: () => {
                    this.onSortClicked(resType, SortType.DATES)
                },
                activeSort: this.state[resType][SortType.DATES].activeSort,
            },
            {
                text: localize("static.content.reservations-nights"),
                sortable: false,
                curSortDirection: SortDirection.ASC,
                onSort: () => {
                },
                activeSort: false,
            },
        )

        //show the rest of the columns if showing All, except for points applied - do not show if res type is canceled
        if (showAll) {
            headers.push(
                {
                    text: confirmationHeader,
                    sortable: false,
                    curSortDirection: SortDirection.ASC,
                    onSort: () => {
                    },
                    activeSort: false,
                },
                {
                    text: localize("static.content.reservations-transaction-date"),
                    sortable: true,
                    curSortDirection: this.state[resType][SortType.TRANSACTION_DATE].curSortDirection,
                    onSort: () => {
                        this.onSortClicked(resType, SortType.TRANSACTION_DATE)
                    },
                    activeSort: this.state[resType][SortType.TRANSACTION_DATE].activeSort,
                },
                {
                    text: localize("static.content.reservations-reservation-type"),
                    sortable: true,
                    curSortDirection: this.state[resType][SortType.RESERVATION_TYPE].curSortDirection,
                    onSort: () => {
                        this.onSortClicked(resType, SortType.RESERVATION_TYPE)
                    },
                    activeSort: this.state[resType][SortType.RESERVATION_TYPE].activeSort,
                },
            );
        }

        if (showAll && resType !== ReservationType.CANCELED) {
            let tip: [Tip] = [
                {
                    label: "",
                    desc: "static.content.tip.reservations-header-points"
                }
            ]
            headers.push(
                {
                    text: localize("static.content.reservations-points-applied"),
                    sortable: false,
                    curSortDirection: SortDirection.ASC,
                    onSort: () => {
                    },
                    activeSort: false,
                    // TODO: commenting out tool tip - will implement at a future date
                    // toolTip: resType === ReservationType.PAST ? tip : undefined,
                    // toolTipPosition: Position.LEFT,
                },
            )
        }

        //always show View column
        headers.push(
            {
                text: "",
                sortable: false,
                curSortDirection: SortDirection.ASC,
                onSort: () => {
                },
                activeSort: false,
            },
        )

        return headers;

    }

    getTransDateNoTime = (date: string | Date): Moment => {
        return moment(date.toString().split('T')[0]);
    };

    /**
     * return the jsx for each cell in the Reservations table
     */
    reservationsTableRows(resType: ReservationType) {
        const showAll = this.showAllColumns();
        sessionStorage.write('HOPPER_RESERVATION_PAGE', false);

        return this.state[resType].reservations.map(reservation => {
            const {localize} = this.context;
            const resDetails = reservation.reservationDetails;
            const transDate = this.getTransDateNoTime(resDetails.transactionDate).format("DD MMM YYYY");
            const siteType = resDetails.managementCompany ? resDetails.managementCompany.siteType : "";
            const siteNodeName = resDetails.managementCompany ? resDetails.managementCompany.nodename : "";

            //confirmation # header text
            let confirmationHeader = localize("static.content.reservations-confirmation");
            let resNumber = resDetails.reservationConfirmationNumber;
            if (resType === ReservationType.PAST) {
                confirmationHeader = localize("static.content.reservations-reservation-num");
                // DIGMVO-616, QA-48140 For Past hopper reservation also show TSW ID which is reservationNumber field from api response
                resNumber = resDetails.reservationNumber.toString();
            }
            if (resType === ReservationType.CANCELED) {
                confirmationHeader = localize("static.content.reservations-reservation-num");
                resNumber = (siteType === SiteType.EXPLORER) && (siteNodeName === 'hopper') ? resNumber : resDetails.reservationNumber.toString();
            }

            const rowCells: any = 
            ((siteType === SiteType.EXPLORER) && (siteNodeName === 'hopper')) ?
            {
                destination: this.getDestinationHotelJSX(resDetails, resType)
            } : 
            {
                destination: this.getDestinationJSX(resType, resDetails)
            }

            if (showAll) {
            ((siteType === SiteType.EXPLORER) && (siteNodeName === 'hopper')) ?
                rowCells.roomType = this.getRoomTypeHotelJSX(resDetails)
                :
                rowCells.roomType = this.getRoomTypeJSX(resType, resDetails)
            }

            rowCells.dates = this.getDatesJSX(resDetails);

            rowCells.nights = this.showResField(ReservationViewFields.NUMBER_NIGHTS, resDetails) &&
                <p aria-label="numOfNights">{resDetails.numOfNights}</p>;

            if (showAll) {
                rowCells.number = <p aria-label="reservationConfirmationNumber">{resNumber}</p>;
                rowCells.transactionDate = <p aria-label="transDate">{transDate}</p>;
                rowCells.reservationType = this.getReservationTypeJSX(resType, resDetails);
                if (resType !== ReservationType.CANCELED) {
                    rowCells.points = <p aria-label="pointsApplied">{resDetails.pointsApplied}</p>;
                }
            }
            const a = resDetails.reservationType ? resDetails.reservationType : "";
            const reservationTypeHotel = resDetails.reservationType ? resDetails.reservationType : "";
            // DIGMVO-208 Hopper Management Company
            if((siteType === SiteType.EXPLORER) && (siteNodeName === 'hopper')) {
                rowCells.view = this.getViewHotelJSX(resDetails.reservationID, resType, resDetails.canCancel, resDetails.reservationType, resNumber);
            } else {
                rowCells.view = this.getViewJSX(resDetails.reservationID, resType, resDetails.canCancel, resDetails.reservationType);
            }
            console.log('UPCOMING_RESERVATIONONE', siteType);
                
            console.log("resDetails",a)
            return {
                rowKey: resDetails.reservationID.toString(),
                rowCells,
                rowExpanded: (
                    <div className="expandedRow">
                        <div className="expandedItem">
                            <span className="expandedLabel">
                                {localize("static.content.reservations-type")}:&nbsp;
                            </span>
                            {this.getRoomTypeJSX(resType, resDetails)}
                        </div>
                        <div className="expandedItem">
                            <span className="expandedLabel">
                                {confirmationHeader}:&nbsp;
                            </span>
                            <p aria-label="reservationConfirmationNumber">{resNumber}</p>
                        </div>
                        <div className="expandedItem">
                            <span className="expandedLabel">
                                {localize("static.content.reservations-transaction-date")}:&nbsp;
                            </span>
                            <p aria-label="transDate">{transDate}</p>
                        </div>
                        <div className="expandedItem">
                            <span className="expandedLabel">
                                {localize("static.content.reservations-reservation-type")}:&nbsp;
                            </span>
                            {this.getReservationTypeJSX(resType, resDetails)}
                        </div>
                        {resType !== ReservationType.CANCELED && <div className="expandedItem">
                            <span className="expandedLabel">
                                {localize("static.content.reservations-points-applied")}:&nbsp;
                            </span>
                            <p aria-label="pointsApplied">{resDetails.pointsApplied}</p>
                        </div>}
                    </div>
                )
            };
        });
    }

    getDestinationJSX(resType: ReservationType, resDetails: ReservationDetailsExtended) {
        //show hyperlink given certain conditions, otherwise just show text
        let showDestinationLink = false;
        const siteType = resDetails.managementCompany ? resDetails.managementCompany.siteType : "";
        if (resType !== ReservationType.CANCELED && (siteType === SiteType.MVC || ((siteType === SiteType.EXCHANGE || siteType === SiteType.EXPLORER)))) {
            showDestinationLink = true;
        }

        if (showDestinationLink) {
            return <>
                <div className="name-address">
                    <div
                        className="resort-name"
                        onClick={() => {
                            switch (siteType) {
                                case SiteType.MVC:
                                    this.toggleResortModal(resDetails.resortId ? resDetails.resortId : "");
                                    break;
                                case SiteType.EXPLORER:
                                    if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
                                        window.location.href = "./exploredestinations/cruisesHotelsandMore";
                                    }
                                    else {
                                        // VCAP
                                        window.location.href = "../CruisesHotelsandMore.jsp";
                                    }
                                    break;
                                case SiteType.EXCHANGE:
                                    if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
                                        window.location.href = "./vacationOptions/points-exchangePartnerResorts/";
                                    }
                                    else {
                                        // VCAP
                                        window.location.href = "../mvcAsiaPacific.jsp";
                                    }
                                    break;
                            }
                        }
                        }
                    >
                        <span>
                            {resDetails.resortName}
                        </span>
                    </div>
                    <div className="resort-address">
                        <span>
                            {siteType === SiteType.MVC ? resDetails.resortLocation : ""}
                        </span>
                    </div>
                </div>
            </>
        } else {
            return <>
                <div className="name-address">
                    <p aria-label="resortName">{resDetails.resortName}</p>
                    <p aria-label="resortLocation">{siteType === SiteType.MVC ? resDetails.resortLocation : ""}</p>
                </div>
            </>
        }
    }

    getDestinationHotelJSX(resDetails: ReservationDetailsExtended, resType: ReservationType) {
        const destinationHotelOne = resDetails.reservationUserFields ? resDetails.reservationUserFields.userField3 : "";
        const destinationHotelTwo = resDetails.reservationUserFields ? resDetails.reservationUserFields.userField5 : "";
        let resNumber: any = resDetails.reservationConfirmationNumber;
        
        return <>
            <div className="name-address">
            {(resType === ReservationType.CANCELED) ?
                <p className="hotel-destination-cancelled" aria-label="resortName">{destinationHotelOne}</p> :
                <p className="hotel-destination-link" aria-label="resortName" onClick={() => this.showHotelConfirmation(true, resNumber)}>{destinationHotelOne}</p>}
                <p aria-label="resortLocation">{destinationHotelTwo}</p>
            </div>
        </>  
    }

    getRoomTypeJSX(resType: ReservationType, resDetails: ReservationDetailsExtended) {
        //room type - show hyperlink given certain conditions, otherwise just show text
        let showRoomTypeLink = false;
        if (resType === ReservationType.UPCOMING && (resDetails.managementCompany && resDetails.managementCompany.siteType === SiteType.MVC)) {
            showRoomTypeLink = true;
        }

        const segments = JSON.parse(sessionStorage.read(ReservationService.SEGMENTS));

        const handleRoomModal = () => {
            this.fetchFloorPlan({
                segments: segments || ["PTS", "INA", "AP2"],
                resorts: [resDetails.resortId],
                codeRoomPoolCode: [resDetails.roomPoolCode]
            })
            this.setState({
                [ModalTypes.ROOM_MODAL]: {
                    ...this.state[ModalTypes.ROOM_MODAL],
                    room: {} as any,
                    show: true,
                },
            })
        }

            return <>
                <div className={`${showRoomTypeLink ? 'room-type' : ''}`}>
                    <span
                        onClick={showRoomTypeLink ? handleRoomModal : undefined}
                        dangerouslySetInnerHTML={{ __html:  resDetails.roomType.description }}
                    >
                    </span>
                </div>
            </>
    }

    getRoomTypeHotelJSX(resDetails: ReservationDetailsExtended) {
        const destinationHotelRoomType = resDetails.reservationUserFields ? resDetails.reservationUserFields.userField4 : "";
        return <>
            <div>
                <span>{destinationHotelRoomType}</span>
            </div>
        </>
    }

    getDatesJSX(resDetails: ReservationDetailsExtended) {
        const checkIn = moment(resDetails.checkInDate).format("DD MMM YYYY");
        const checkOut = resDetails.checkOutDate ? moment(resDetails.checkOutDate).format("DD MMM YYYY") : "";

        return <div>
            {this.showResField(ReservationViewFields.CHECK_IN, resDetails) &&
            <div>
                <span>
                    {checkIn}
                </span>
            </div>
            }
            {this.showResField(ReservationViewFields.CHECK_OUT, resDetails) &&
            <div>
                <span>
                    {checkOut ? checkOut : ""}
                </span>
            </div>
            }
        </div>
    }

    showResField(resViewField: ReservationViewFields, resDetails: ReservationDetailsExtended) {
        return showReservationField(resViewField, resDetails);
    }

    getReservationTypeJSX(resType: ReservationType, resDetails: ReservationDetailsExtended) {
        let showPopup = false;
        if (
            (resType === ReservationType.UPCOMING || resType === ReservationType.PAST)
            && (resDetails.managementCompany && resDetails.managementCompany.name !== ManagementCompanyType.MVC)
            && (resDetails.managementCompany && (resDetails.managementCompany.phone || resDetails.managementCompany.url))
            && (this.showResField(ReservationViewFields.HOVER_POP_UP, resDetails))
        ) {
            showPopup = true;
        }

       if (showPopup && resDetails.managementCompany) {
            return (
                <div className="reservation-type-container">
                    <MvReservationTypeToolTip
                        resID={resDetails.reservationID}
                        managementCompany={resDetails.managementCompany}
                        position={Position.CENTER}
                    >
                        <span key={resDetails.reservationID} aria-label="reservationType"
                              className="reservation-type">{resDetails.reservationType}</span>
                    </MvReservationTypeToolTip>
                </div>
            );
        } else {
            return <>
                <p aria-label="reservationType">{resDetails.reservationType}</p>
            </>
        }
    }

    getViewJSX = (resId: number, resType: ReservationType, disableVoaCancelCapability?: boolean, resDetailsResType?: string) => {
        const {localize} = this.context;
        return <div className='table-actions'>
            <div className="view-link">
                <span onClick={() => this.goToViewReservation(resId, resType, resDetailsResType)}>
                    {localize("static.content.reservations-view-link")}
                </span>
            </div>
            {this.state.activeBtn === ReservationType.UPCOMING && !disableVoaCancelCapability && <div style={{ marginTop: '5px' }} className="view-link">
                <span onClick={() => this.handleCancelMessage(resId, resType)}>
                {localize("static.content.cancellation-cancel-cta")}
                </span>
            </div>}
        </div>
    }

     getViewHotelJSX = (resId: number, resType: ReservationType, disableVoaCancelCapability?: boolean, resDetailsResType?: string, resNumber?: any) => {
        const {localize} = this.context;
        return <div className='table-actions'>
            <div className="view-link">
                <span onClick={() => this.goToViewReservationHopper(resId, resType, resDetailsResType)}>
                    {localize("static.content.reservations-view-link")}
                </span>
            </div>
            {(resType === ReservationType.CANCELED) || (resType === ReservationType.PAST)?
            <div></div> :
            <div style={{ marginTop: '5px' }} className="view-link">
                {/* <span onClick={() => this.handleCancelMessage(resId, resType)}>
                 Hopper Cancel
                </span> */}
                <span onClick={() => this.showHotelConfirmation(true, resNumber)}>
                    {localize("static.content.cancellation-cancel-cta")}
                </span>
            </div>
            }
        </div>
    }

    goToCancelReservation = (resId: number, resType: ReservationType) => {
        this.props.setScreenType(ScreenType.CANCEL_RESERVATION, resId, undefined, resType);
    }

    showHotelConfirmation = (confirmationFlag: boolean, reservationConfirmationNumber: number) => {
        this.setState({showHotelConfirmation: confirmationFlag, reservationConfirmationNum: reservationConfirmationNumber});
    }

    toggleModalHotel = () => {
        this.setState({showHotelConfirmation: false});
    };

    confirmHotelCancel = () => {
        //TODO: DIGMVO-210
        const {localize} = this.context;
        const queryString: string = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        let mpmId: any = String(urlParams.get('mpmId'));
        let ctaType: any = String(urlParams.get('ctaType'));
        const vcapmpmid = window.sessionStorage.getItem('VCAP_MPM_ID');
        const vcapclubtype = window.sessionStorage.getItem('VCAP_CLUB_CODE');
        const ssoTokenForReact:any = window.sessionStorage.getItem('EXP_API_TKN');
        const reservationConfirmationNum = this.state.reservationConfirmationNum;
        if(mpmId === 'null' || undefined || '') {
            mpmId = vcapmpmid;
        }
        if(ctaType === 'null' || undefined || '') {
            ctaType = vcapclubtype;
        }
        const cancelBaseUrl = String(localize("static.content.cancel-reservation-link"));
        const cancelBaseParams: any = {ownerId: mpmId, clubCode: ctaType, token: ssoTokenForReact, confirmationNumber: reservationConfirmationNum}
        const CANCEL_HOPPER_BASE_PARAMS_URL = cancelBaseUrl.replace(/\{(.*?)\}/g, (match, key) => cancelBaseParams[key] || match);
        console.log('CANCEL_HOPPER_BASE_PARAMS_URL', CANCEL_HOPPER_BASE_PARAMS_URL);
        window.open(CANCEL_HOPPER_BASE_PARAMS_URL)
    }

    abortModalHotel = () => {
        this.setState({showHotelConfirmation: false});
    }

    handleCancelMessage = async (resId: number, resType: ReservationType) => {
        /** Below line of code to track data for adobe */
        trackAnalyticData('cancelUpcomingTrip');
        const reservationService = new ReservationService();
        const newState = {...this.state};
        const {localize} = this.context;
        newState[ReservationType.UPCOMING].requestStatus = RequestStatus.LOADING;
        this.setState(newState);
        try {
            var reservationPayload = await reservationService.getReservation(resId, resType);
            if (reservationPayload.canCancel) {
                this.goToCancelReservation(resId, resType)
            } else {
                let cancelMessage = ''
                switch (reservationPayload.ruleName) {
                    case 'TSW_INVALID_RESERVATION_TYPE': 
                        cancelMessage = localize("static.content.cancel-tsw-invalid-reservation-type");
                        break;
                    case 'TSW_MARSHA_DATA_MISMATCH': 
                        cancelMessage = localize("static.content.cancel-tsw-marsha-data-mismatch");
                        break;
                    case 'TSW_NO_CANCEL_PREVIEW_RESPONSE': 
                        cancelMessage = localize("static.content.cancel-tsw-no-cancel-preview-response");
                        break;
                    default:
                        cancelMessage = reservationPayload.ruleName || '';
                        break;
                }
                this.setState({ showUnavailableModal: true, cancelMessage })
            }
        } catch (e) {
            this.setState({ showUnavailableModal: true, cancelMessage: localize("static.content.cancel-api-failure") })
        } finally {
            const newState = {...this.state};
            newState[ReservationType.UPCOMING].requestStatus = RequestStatus.LOADED;
            this.setState(newState);
        }

    }

    goToViewReservation = (resId: number, resType: ReservationType, resDetailsResType?: string) => {
        sessionStorage.write('reservationType', resDetailsResType);
        if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            this.props.setScreenType(ScreenType.VIEW_RESERVATION, resId, undefined, resType); // 1C code add undefined parameter
        }
        else {
            // VCAP (production)
            window.location.href = `/viewReservation.jsp?resId=${resId}&resType=${resType}`;
        }
    };

    goToViewReservationHopper = (resId: number, resType: ReservationType, resDetailsResType?: string) => {
        sessionStorage.write('reservationType', resDetailsResType);
        sessionStorage.write('HOPPER_RESERVATION_PAGE', true);
        if ([ReactAppMode.VOA, ReactAppMode.LOCAL].includes(EXEC_MODE)) {
            this.props.setScreenType(ScreenType.VIEW_RESERVATION, resId, undefined, resType); // 1C code add undefined parameter
        }
        else {
            // VCAP (production)
            window.location.href = `/viewReservation.jsp?resId=${resId}&resType=${resType}`;
        }
    };

    getColumnStyles(resType: ReservationType) {
        let columnStyles: { [key: string]: CSSProperties } = {
            "0": {
                flex: "1"
            },
            "1": {
                flex: "1"
            },
            "2": {
                flex: "120px 0 0"
            },
            "3": {
                flex: "80px 0 0"
            },
            "4": {
                flex: "125px 0 0"
            },
            "5": {
                flex: "150px 0 0",
            },
            "6": {
                flex: "150px 0 0",
            },
            "7": {
                flex: "110px 0 0",
            },
            "8": {
                flex: "50px 0 0"
            }
        }
        //cancelled list removes points applied (column #7 above)
        if (resType === ReservationType.CANCELED) {
            columnStyles = {
                "0": {
                    flex: "1"
                },
                "1": {
                    flex: "1"
                },
                "2": {
                    flex: "120px 0 0"
                },
                "3": {
                    flex: "80px 0 0"
                },
                "4": {
                    flex: "125px 0 0"
                },
                "5": {
                    flex: "150px 0 0",
                },
                "6": {
                    flex: "150px 0 0",
                },
                "7": {
                    flex: "50px 0 0",
                }
            }
        }
        if (!this.showAllColumns()) {
            columnStyles = {
                "0": {
                    flexBasis: '30%'
                },
                "3": {
                    flex: "50px 0 0"
                }
            }
        }
        return columnStyles;
    }

    toggleResortModal(propertyCode: string) {
        this.setState({
            resortModal: {
                propertyCode,
                show: !this.state.resortModal.show,
            },
        });
    }

    /**
     * fired when a column sort icon is clicked in the Reservation list table
     */
    onSortClicked(reservationType: ReservationType, sortField: SortType) {
        const table = {...this.state[reservationType]};
        const reservations = [...table.reservations];

        let sortDirection = table[sortField].curSortDirection;
        if (table[sortField].activeSort) {
            sortDirection = table[sortField].curSortDirection === SortDirection.ASC ?
                SortDirection.DESC : SortDirection.ASC;
        }

        console.log({onSortClicked_sortDirection: sortDirection})

        const sortedReservations = sortReservations(
            reservations,
            reservationType,
            sortField,
            sortDirection
        );

        table[sortField].activeSort = true;
        table[sortField].curSortDirection = sortDirection;
        table.reservations = [...sortedReservations];

        // reset other sort active flags to false and directions to default
        if (sortField !== SortType.DATES) {
            let defaultSortDirection = SortDirection.DESC;
            if (reservationType === ReservationType.UPCOMING)
                defaultSortDirection = SortDirection.ASC;
            table[SortType.DATES].curSortDirection = defaultSortDirection;
            table[SortType.DATES].activeSort = false;
        }
        if (sortField !== SortType.TRANSACTION_DATE) {
            table[SortType.TRANSACTION_DATE].curSortDirection = SortDirection.DESC;
            table[SortType.TRANSACTION_DATE].activeSort = false;
        }
        if (sortField !== SortType.RESERVATION_TYPE) {
            table[SortType.RESERVATION_TYPE].curSortDirection = SortDirection.ASC;
            table[SortType.RESERVATION_TYPE].activeSort = false;
        }
        if (sortField !== SortType.DESTINATION) {
            table[SortType.DESTINATION].curSortDirection = SortDirection.ASC;
            table[SortType.DESTINATION].activeSort = false;
        }

        const newState = {...this.state};
        newState[ReservationType[reservationType]] = table;
        this.setState(newState);
    }

    getYearFromDate(date: string | Date) {
        const checkIn = moment(date).format("YYYY");
        if (checkIn && checkIn.length) {
            return Number(checkIn);
        }
        return 0
    }

    onYearFilterSelection(years: DropdownOption[], resType: ReservationType) {
        if (this.state && this.state[resType] && this.state[resType].totalReservations) {
            const selectedOptions = years.filter((item) => {
                return item.checked;
            })
            let selectedYears = selectedOptions.map(item => Number(item.year))
            // TODO: This may need when we want to implement default year logic 
            // if (selectedYears && selectedYears.length === 0) {
            //     selectedYears = this.state[resType].defaultYears;
            // }
            const totalReservations = [...this.state[resType].totalReservations];
            if (totalReservations && totalReservations.length) {
                let filteredReservations = [];
                filteredReservations = totalReservations.filter((item) => {
                    return selectedYears.includes(this.getYearFromDate(item.reservationDetails.checkInDate))
                });
                if (selectedYears && selectedYears.length === 0) {
                    filteredReservations = totalReservations;
                }
                this.setState({
                    ...this.state,
                    [resType]: {
                        ...this.state[resType],
                        reservations: filteredReservations
                    }
                })
            }

        }
    }


    /**
     * toggle a modal of a given type
     */
    toggleModal = (modalType: ModalTypes): void => {
        if (this.state[modalType].show == true) {
            this.setState({roomModalLoaded: false})
            console.log('(*(&&^%^&*(')
        }
        this.setState({
            [modalType]: {
                ...this.state[modalType],
                show: !this.state[modalType].show
            },
        } as any);
    }

    fetchFloorPlan(roomParams: any) {
        this.reservationService.searchRoomInfo(roomParams).then(res => {
            this.setState({
                singleRoomInfo: res,
                roomModalLoaded: true,
            });
        });
    }

    render() {
        const {localize} = this.context;

        return (
            <>
            <MvHopperConfirmationModal
                header={localize("static.content.third-party-modal-title")}
                description={localize("static.content.third-party-modal-description")}
                message=""
                abortLabel={localize("static.content.no-button-label")}
                confirmLabel={localize("static.content.yes-button-label")}
                closeiconnato={true}
                openModal={this.state.showHotelConfirmation}
                toggleModal={this.toggleModalHotel}
                confirm={this.confirmHotelCancel}
                abort={this.abortModalHotel}
            />
            <div className='reservations-page'>
                <h2 className="table-title">{localize("static.content.view-res-page-header")}</h2>
                <RBContainer setActive={this.setActive} activeBtn={this.state.activeBtn.toString()}/>
                <CancelUnavaliableModal
                    openModal={this.state.showUnavailableModal}
                    toggleModal={this.toggleshowUnavailableModal}
                    message={this.state.cancelMessage}
                />
                <MvConfirmationModal
                    header="Error"//{localize("static.content.reservations-error-header")}
                    description={this.state.errorMessage}
                    message=""
                    abortLabel=""
                    confirmLabel={localize("OK")} //{localize("static.content.reservations-confirm-error")}
                    openModal={this.state.showErrorModal}
                    toggleModal={this.toggleErrorModal}
                    confirm={this.toggleErrorModal}
                    abort={() => {
                    }}
                />
                <div className="reservations-container">
                    <MvRoomModal
                        toggle={() => this.toggleModal(ModalTypes.ROOM_MODAL)}
                        data={{...this.state[ModalTypes.ROOM_MODAL], ...this.state.singleRoomInfo[0]}}
                        fetchLoaded={this.state.roomModalLoaded}
                    />
                    <MvResortModal
                        show={this.state.resortModal.show}
                        propertyCode={this.state.resortModal.propertyCode}
                        toggle={() => this.setState({
                            resortModal: {
                                ...this.state.resortModal,
                                show: !this.state.resortModal.show
                            }
                        })}
                    />
                    {(this.state.activeBtn === ReservationType.UPCOMING) && console.log('UPCOMING_RESERVATION', this.state['UPCOMING'].reservations)
}
                    {(this.state.activeBtn === ReservationType.UPCOMING) &&
                    <MvSortTable
                        rowKey="resId"
                        headers={this.reservationsTableHeaders(ReservationType.UPCOMING)}
                        rows={this.reservationsTableRows(ReservationType.UPCOMING)}
                        rowsExpandable={!this.showAllColumns()}
                        dataStatus={this.state[ReservationType.UPCOMING].requestStatus}
                        headerSection={
                            <div className="reservations-header">
                                <h4>
                                    {localize("static.content.view-res-page-upcoming")}
                                </h4>
                                <span className="reservations-subheader">
                                    {localize("static.content.view-res-page-subheading")}
                                </span>
                                {this.state[ReservationType.UPCOMING].requestStatus === RequestStatus.LOADED && this.state[ReservationType.UPCOMING].reservations.length === 0 &&
                                  <div
                                  className="reservations-none">{localize("You currently do not have any upcoming reservations")}</div>
                                }
                            </div>
                        }
                        minWidth={1}
                        columnStyles={this.getColumnStyles(ReservationType.UPCOMING)}
                        apiTimeout = {this.props.apiTimeout}
                    />
                    }
                    {(this.state.activeBtn === ReservationType.PAST) &&
                    <MvSortTable
                        rowKey="resId"
                        headers={this.reservationsTableHeaders(ReservationType.PAST)}
                        rows={this.reservationsTableRows(ReservationType.PAST)}
                        rowsExpandable={!this.showAllColumns()}
                        dataStatus={this.state[ReservationType.PAST].requestStatus}
                        headerSection={
                            <div className="reservations-header">
                                <h4>
                                    {localize("static.content.view-res-page-past")}
                                </h4>
                                <span className="reservations-subheader">
                                    {localize("static.content.view-res-page-subheading-past")}
                                </span>
                                {this.state[ReservationType.PAST].requestStatus === RequestStatus.LOADED && this.state[ReservationType.PAST].reservations.length === 0 &&
                                <div
                                    className="reservations-none">{localize("You currently do not have any past reservations for the given years")}</div>
                                }
                                <span className="multi-select-year-filter">
                                     <MultiSelectDate options={this.state[ReservationType.PAST].datesFilter}
                                                      onChangeFilter={(years) => {
                                                          this.onYearFilterSelection(years, ReservationType.PAST)
                                                      }}
                                                      label={localize("static.content.view-res-more-filters")}></MultiSelectDate>
                                </span>
                            </div>
                        }
                        minWidth={1}
                        columnStyles={this.getColumnStyles(ReservationType.PAST)}
                        apiTimeout = {this.props.apiTimeout}
                    />
                    }
                    {(this.state.activeBtn === ReservationType.CANCELED) &&
                    <MvSortTable
                        rowKey="resId"
                        headers={this.reservationsTableHeaders(ReservationType.CANCELED)}
                        rows={this.reservationsTableRows(ReservationType.CANCELED)}
                        rowsExpandable={!this.showAllColumns()}
                        dataStatus={this.state[ReservationType.CANCELED].requestStatus}
                        headerSection={
                            <div className="reservations-header">
                                <h4>
                                    {localize("static.content.view-res-page-canceled")}
                                </h4>
                                <span className="reservations-subheader">
                                    {localize("static.content.view-res-page-subheading-canceled")}
                                </span>
                                {this.state[ReservationType.CANCELED].requestStatus === RequestStatus.LOADED && this.state[ReservationType.CANCELED].reservations.length === 0 &&
                                <div
                                    className="reservations-none">{localize("You currently do not have any cancelled reservations for the given years")}</div>
                                }
                                <span className="multi-select-year-filter">
                                    <MultiSelectDate options={this.state[ReservationType.CANCELED].datesFilter}
                                                     onChangeFilter={(years) => {
                                                         this.onYearFilterSelection(years, ReservationType.CANCELED)
                                                     }}
                                                     label={localize("static.content.view-res-more-filters")}></MultiSelectDate>
                                </span>
                            </div>
                        }
                        minWidth={1}
                        columnStyles={this.getColumnStyles(ReservationType.CANCELED)}
                        apiTimeout = {this.props.apiTimeout}
                    />
                    }
                </div>
            </div>
           </> 
        );
    }

};

Reservations.contextType = LocalizationContext;
export {
    Reservations,
};